<template>
  <v-layout align-center align-baseline justify-center>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="formularios"
        :search="search"
        class="elevation-1"
        v-if="verNuevo == 0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Bauchers</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  icon
                  color="green"
                  v-bind="attrs"
                  v-on="on"
                  @click="listar()"
                  ><v-icon class="fa fa-sync-alt"></v-icon
                ></v-btn>
              </template>
              <span>Actualizar</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-menu
              v-if="verNuevo == 0"
              v-model="menuFechas"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-y
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Opciones</v-btn
                >
              </template>
              <v-card>
                <v-list>
                  <v-list-item>
                    <v-text-field
                      hide-details
                      type="date"
                      label="Desde"
                      v-model="fechaInicio"
                      :max="new Date().toISOString().substr(0, 10)"
                      clearable
                    ></v-text-field>
                  </v-list-item>

                  <v-list-item>
                    <v-text-field
                      hide-details
                      type="date"
                      label="Hasta"
                      v-model="fechaFin"
                      :max="new Date().toISOString().substr(0, 10)"
                      clearable
                    ></v-text-field>
                  </v-list-item>
                  <v-list-item>
                    <v-btn color="primary" dark @click="listarBusqueda()"
                      >Filtrar</v-btn
                    >
                    <v-btn
                      class="mx-2"
                      color="green"
                      dark
                      @click="descargarExcel()"
                      >Descargar</v-btn
                    >
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
            <v-btn v-if="verNuevo == 0" color="primary" @click="abrirNuevo()"
              >Nuevo</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="verDetalles(item)"> tab </v-icon>
        </template>
      </v-data-table>

      <v-overlay v-model="overlay" z-index="1">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>

      <v-snackbar v-model="snackError" color="cyan darken-2" top
        >SUCEDIO ALGUN ERROR, VERIFICAR ESTADO DE CONEXIÓN, Y VUELVA A
        INTENTAR.</v-snackbar
      >

      <v-row v-if="verNuevo == 1">
        <v-col cols="12" class="pa-0">
          <v-toolbar>
            <v-col cols="auto">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-x
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="indigo" dark v-bind="attrs" v-on="on">
                    Opciones
                  </v-btn>
                </template>
                <v-card>
                  <v-list>
                    <v-list-item>
                      <v-select
                        v-model="chequeTransferencia"
                        :items="items"
                        hint="Seleccione si es numero de cheque o transferencia"
                        persistent-hint
                      ></v-select>
                    </v-list-item>
                    <v-list-item>
                      <v-select
                        v-model="banco"
                        :items="itemsBanco"
                        hint="Seleccione el banco"
                        persistent-hint
                      ></v-select>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn @click="cerrarNuevo()" outlined rounded color="grey"
              >Cancelar</v-btn
            >
            <v-btn
              outlined
              rounded
              color="blue"
              @click="imprimir()"
              class="ml-5"
              >Imprimir</v-btn
            >
            <v-btn
              outlined
              rounded
              color="blue"
              @click="actualizar()"
              class="ml-5"
              v-if="verBaucher == 1"
              >Actualizar</v-btn
            >
            <v-btn
              outlined
              rounded
              color="blue"
              @click="guardar()"
              class="ml-5"
              v-if="verBaucher != 1"
              >Guardar</v-btn
            >
          </v-toolbar>
        </v-col>
        <v-col cols="6" class="mx-auto">
          <v-autocomplete
            v-model="nombreProveedorItem"
            :items="itemsProveedor"
            item-text="proveedor"
            return-object
            label="Nombre de proveedor"
            @change="verProveedor()"
            :loading="nombreProveedorItem.length < 0"
          ></v-autocomplete>
        </v-col>
        <vue-html2pdf
          :show-layout="true"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="F1"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="792px"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf"
          class="mx-auto"
        >
          <section slot="pdf-content">
            <v-col cols="12">
              <v-card
                max-width="792"
                height="auto"
                elevation="0"
                style="
                  border: 1px solid black;
                  margin-left: 25px;
                  margin-right: 25px;
                  margin-top: 25px;
                "
              >
                <v-row class="ma-1">
                  <v-col cols="auto" class="textStyle">
                    <div class="styleText">RECIBO No:</div>
                  </v-col>
                  <v-col
                    cols="3"
                    style="
                      padding-left: 5px;
                      padding-top: 0px;
                      margin-top: 10px;
                    "
                  >
                    <v-text-field
                      v-model="correlativo"
                      hide-details
                      readonly
                      dense
                      height="15"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-1">
                  <v-col cols="auto" class="textStyle">
                    <div class="styleText">{{ chequeTransferencia }}:</div>
                  </v-col>
                  <v-col
                    cols="3"
                    style="
                      padding-left: 5px;
                      padding-top: 0px;
                      margin-top: 10px;
                    "
                  >
                    <v-text-field
                      v-model="numeroChequeTransferencia"
                      hide-details
                      dense
                      height="15"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-1">
                  <v-col cols="auto" class="textStyle">
                    <div class="styleText">BANCO:</div>
                  </v-col>
                  <v-col
                    cols="6"
                    style="
                      padding-left: 5px;
                      padding-top: 0px;
                      margin-top: 10px;
                    "
                  >
                    <v-text-field
                      v-model="banco"
                      hide-details
                      dense
                      height="15"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <v-card max-width="792" height="auto" elevation="0">
                <v-row
                  class="ma-1"
                  style="
                    justify-content: space-between;
                    padding-left: 25px;
                    padding-right: 25px;
                  "
                >
                  <v-col cols="3.5">
                    <v-text-field hide-details></v-text-field>
                  </v-col>
                  <v-col cols="3.5">
                    <v-text-field hide-details></v-text-field>
                  </v-col>
                  <v-col cols="3.5">
                    <v-text-field hide-details></v-text-field>
                  </v-col>
                </v-row>
                <v-row
                  class="ma-1"
                  style="
                    justify-content: space-between;
                    padding-left: 25px;
                    padding-right: 25px;
                  "
                >
                  <v-col cols="3.5">
                    <div class="styleText" style="text-align: center">ELABORADO</div>
                  </v-col>
                  <v-col cols="3.5">
                    <div class="styleText" style="text-align: center">REVISADO</div>
                  </v-col>
                  <v-col cols="3.5">
                    <div class="styleText" style="text-align: center">AUTORIZADO</div>
                  </v-col>
                </v-row>
              </v-card>

              <v-card max-width="792" height="auto" elevation="0">
                <v-row class="ma-1">
                  <v-col cols="auto" class="textStyle">
                    <div class="styleText">RECIBI DE:</div>
                  </v-col>
                  <v-col
                    cols="7"
                    style="
                      padding-left: 5px;
                      padding-top: 0px;
                      margin-top: 10px;
                    "
                  >
                    <v-text-field
                      v-model="recibiDe"
                      hide-details
                      dense
                      height="15"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-1">
                  <v-col cols="auto" class="textStyle">
                    <div class="styleText">LA CANTIDAD DE:</div>
                  </v-col>
                  <v-col
                    cols="6"
                    style="
                      padding-left: 5px;
                      padding-top: 0px;
                      margin-top: 10px;
                    "
                  >
                    <v-text-field
                      v-model="cantidadDe"
                      hide-details
                      dense
                      height="15"
                       class="styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-1">
                  <v-col cols="auto" class="textStyle">
                    <div class="styleText">EN CONCEPTO DE:</div>
                  </v-col>
                  <v-col
                    cols="6"
                    style="
                      padding-left: 5px;
                      padding-top: 0px;
                      margin-top: 10px;
                    "
                  >
                    <v-text-field
                      v-model="conceptoDe"
                      hide-details
                      dense
                      height="15"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-1">
                  <v-col cols="auto" class="textStyle">
                    <div class="styleText">NOMBRE DE QUIEN RECIBI:</div>
                  </v-col>
                  <v-col
                    cols="5"
                    style="
                      padding-left: 5px;
                      padding-top: 0px;
                      margin-top: 10px;
                    "
                  >
                    <v-text-field
                      v-model="quienRecibi"
                      hide-details
                      dense
                      height="15"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-1">
                  <v-col cols="auto" class="textStyle">
                    <div class="styleText">No DE DUI:</div>
                  </v-col>
                  <v-col
                    cols="2"
                    style="
                      padding-left: 5px;
                      padding-top: 0px;
                      margin-top: 10px;
                    "
                  >
                    <v-text-field
                      v-model="dui"
                      hide-details
                      dense
                      height="15"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="auto" class="textStyle">
                    <div class="styleText">No DE NIT:</div>
                  </v-col>
                  <v-col
                    cols="3"
                    style="
                      padding-left: 5px;
                      padding-top: 0px;
                      margin-top: 10px;
                    "
                  >
                    <v-text-field
                      v-model="nit"
                      hide-details
                      dense
                      height="15"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-1">
                  <v-col cols="auto" class="textStyle">
                    <div class="styleText">NCR:</div>
                  </v-col>
                  <v-col
                    cols="2"
                    style="
                      padding-left: 5px;
                      padding-top: 0px;
                      margin-top: 10px;
                    "
                  >
                    <v-text-field
                      v-model="ncr"
                      hide-details
                      dense
                      height="15"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="auto" class="textStyle">
                    <div class="styleText">CUENTA BANCO:</div>
                  </v-col>
                  <v-col
                    cols="4"
                    style="
                      padding-left: 5px;
                      padding-top: 0px;
                      margin-top: 10px;
                    "
                  >
                    <v-text-field
                      v-model="cuentaBanco"
                      hide-details
                      dense
                      height="15"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <v-card max-width="792" height="auto" elevation="0">
                <!-- HONORARIOS -->
                <v-row class="ma-1">
                  <v-col cols="auto" class="textStyleHonorarios">
                    <div class="styleText">MONTO</div>
                  </v-col>
                  <v-col cols="4" class="styleLine">
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="auto" class="styleDolar">$</v-col>
                  <v-col cols="auto" class="styleNumeros">
                    <v-text-field
                      type="number"
                      v-model="honorarios"
                      hide-details
                      flat
                      solo
                      dense
                      height="15"
                      @change="calculoTotal()"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-1">
                  <!-- RENTA -->
                  <v-col cols="auto" class="textStyleRenta">
                    <div class="styleText">RENTA (-)</div>
                  </v-col>
                  <v-col cols="4" class="styleLine">
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="auto" class="styleDolar">$</v-col>
                  <v-col cols="auto" class="styleNumeros">
                    <v-text-field
                      v-model="renta"
                      type="number"
                      hide-details
                      flat
                      solo
                      dense
                      height="15"
                      @change="calculoTotal()"
                      class="styleText"
                      >{{ renta }}</v-text-field
                    >
                  </v-col>
                </v-row>
                <v-row class="ma-1">
                  <!-- SUB TOTAL -->
                  <v-col cols="auto" class="textStyleSubTotal">
                    <div class="styleText">SUB TOTAL</div>
                  </v-col>
                  <v-col cols="4" class="styleLine">
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="auto" class="styleDolar">$</v-col>
                  <v-col cols="auto" class="styleNumeros">
                    <v-text-field
                      dense
                      flat
                      solo
                      hide-details
                      height="15"
                      v-model="subTotal"
                      type="number"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <!-- IVA -->
                <v-row class="ma-1">
                  <v-col cols="auto" class="textStyleIVA">
                    <div class="styleText">IVA</div>
                  </v-col>
                  <v-col cols="4" class="styleLine">
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="auto" class="styleDolar">$</v-col>
                  <v-col cols="auto" class="styleNumeros">
                    <v-text-field
                      type="number"
                      v-model="iva"
                      hide-details
                      flat
                      solo
                      dense
                      height="15"
                      @change="calculoTotal()"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <!-- TOTAL -->
                <v-row class="ma-1">
                  <v-col cols="auto" class="textStyleTotal">
                    <div class="styleText">TOTAL</div>
                  </v-col>
                  <v-col cols="4" class="styleLine">
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="auto" class="styleDolar">$</v-col>
                  <v-col cols="auto" class="styleNumeros">
                    <v-text-field
                      type="number"
                      v-model="total"
                      hide-details
                      flat
                      solo
                      dense
                      height="15"
                      @change="calculoTotal()"
                      class="styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <v-row class="ma-1">
                <v-col cols="auto" class="textStyle">
                  <div class="styleText">FIRMA DE QUIEN RECIBE:</div>
                </v-col>
                <v-col
                  cols="5"
                  style="padding-left: 5px; padding-top: 0px; margin-top: 10px"
                >
                  <v-text-field hide-details dense height="15"></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-1 styleFecha">
                <v-col class="styleText" cols="auto">
                  {{ fechaBD }}
                </v-col>
              </v-row>
            </v-col>
          </section>
        </vue-html2pdf>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
import XLSX from "xlsx";
export default {
  data() {
    return {
      items: ["NUMERO DE CHEQUE", "NUMERO DE TRASNFERENCIA"],
      itemsBanco: ["AGRICOLA", "AMERICA CENTRAL"],
      chequeTransferencia: "NUMERO DE CHEQUE",
      itemsProveedor: [],
      nombreProveedorItem: "",
      verNuevo: 0,
      verBaucher: 0,
      overlay: false,
      snackError: false,
      search: "",
      menu: false,
      formularios: [],
      dataExcel: [],
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Correlativo",
          value: "correlativo",
          align: "left",
        },
        {
          text: "Fecha",
          value: "fecha",
          align: "left",
        },
        {
          text: "Numero cheque o transferencia",
          align: "left",
          value: "numeroChequeTransferencia",
        },
        {
          text: "Banco",
          align: "left",
          value: "banco",
        },
        {
          text: "Nombre quien recibí",
          align: "left",
          value: "quienRecibi",
        },
      ],
      idBaucher: "",
      idUsuario: "",
      idbaseproveedorBaucher: "",
      correlativo: "",
      fecha: "",
      numeroChequeTransferencia: "",
      banco: "",
      recibiDe: "ASISTENCIA REGIONAL EL SALVADOR",
      cantidadDe: "",
      conceptoDe: "",
      quienRecibi: "",
      dui: "",
      nit: "",
      ncr: "",
      cuentaBanco: "",
      splitNumeroChequeTransferencia: "",
      fechaBD: "",
      año: "",
      mes: "",
      contadorID: 0,
      honorarios: 0,
      renta: 0,
      subTotal: 0,
      iva: 0,
      total: 0,
      menuFechas: false,
      fechaInicio: "",
      fechaFin: "",
    };
  },
  components: {
    VueHtml2pdf,
  },
  created() {
    this.listar();
  },

  methods: {
    listarBusqueda() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.formularios = [];
      me.overlay = true;
      axios
        .get(
          "api/FormBauchers/FiltrarServicios/" +
            me.fechaInicio +
            "/" +
            me.fechaFin,
          configuracion
        )
        .then(function (response) {
          if (response.status == 200) {
            me.overlay = false;
          }
          me.formularios = response.data;
        })
        .catch(function (error) {
          console.log(error);
          me.snackError = true;
          me.overlay = false;
        });
    },
    abrirNuevo() {
      this.verNuevo = 1;
      var today = new Date();
      this.año = today.getFullYear();
      this.mes = today.getMonth() + 1;
      this.correlativo =
        this.año.toString() + this.mes.toString() + this.contadorID.toString();
      this.fecha =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      var opciones = { year: "numeric", month: "long", day: "numeric" };
      this.fechaBD = new Date(this.fecha).toLocaleDateString("es-Es", opciones);
      this.obtenerProveedores();
    },
    cerrarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },
    listar() {
      let me = this;
      me.contadorID = 0;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.formularios = [];
      me.overlay = true;
      axios
        .get("api/FormBauchers/Listar", configuracion)
        .then(function (response) {
          if (response.status == 200) {
            me.overlay = false;
          }
          me.formularios = response.data;
          //PARA PODER GENERAR UN CORRELATIVO SE BUSCA DE LA BASE DE DATOS EL ULTIMO ID DE idBausher y se incrementa en uno.
          for (let i = 0; i < response.data.length; i++) {
            me.contadorID++;
          }
          me.contadorID = me.contadorID + 1;
        })
        .catch(function (error) {
          console.log(error);
          me.snackError = true;
          me.overlay = false;
        });
    },
    obtenerProveedores() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/BaseProveedoresBauchers/Listar", configuracion)
        .then(function (response) {
          //console.log(response.data);
          me.itemsProveedor = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    verProveedor() {
      this.idbaseproveedorBaucher =
        this.nombreProveedorItem.idBaseProveedorBaucher;
      this.quienRecibi = this.nombreProveedorItem.nombrePropietario;
      this.dui = this.nombreProveedorItem.dui;
      this.nit = this.nombreProveedorItem.nit;
      this.ncr = this.nombreProveedorItem.registroFiscal;
      this.cuentaBanco =
        this.nombreProveedorItem.banco + " #" + this.nombreProveedorItem.cuenta;
    },
    verDetalles(item) {
      this.limpiar();
      this.obtenerProveedores();
      var d = new Date(item.fecha);
      var opciones = { year: "numeric", month: "long", day: "numeric" };
      this.fechaBD = d.toLocaleDateString("es-ES", opciones);
      if (item.numeroChequeTransferencia) {
        this.splitNumeroChequeTransferencia =
          item.numeroChequeTransferencia.split("-");
      }

      if (this.splitNumeroChequeTransferencia[0] == "T") {
        this.chequeTransferencia = "NUMERO DE TRASNFERENCIA";
      } else {
        this.chequeTransferencia = "NUMERO DE CHEQUE";
      }
      this.idBaucher = item.idBaucher;
      this.idUsuario = item.idUsuario;
      this.idbaseproveedorBaucher = item.idbaseproveedorBaucher;
      this.correlativo = item.correlativo;
      this.fecha = item.fecha;
      this.numeroChequeTransferencia = this.splitNumeroChequeTransferencia[1];
      this.banco = item.banco;
      this.recibiDe = item.recibiDe;
      this.cantidadDe = item.cantidadDe;
      this.conceptoDe = item.conceptoDe;
      this.quienRecibi = item.quienRecibi;
      this.dui = item.dui;
      this.nit = item.nit;
      this.ncr = item.ncr;
      this.cuentaBanco = item.cuentaBanco;
      this.honorarios = item.honorarios;
      this.renta = item.renta;
      this.subTotal = item.subTotal;
      this.iva = item.iva;
      this.total = item.total;
      this.verNuevo = 1;
      this.verBaucher = 1;
    },
    guardar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.overlay = true;
      var honorarios = parseFloat(me.honorarios);
      var renta = parseFloat(me.renta);
      var subTotal = parseFloat(me.subTotal);
      if (me.chequeTransferencia == "NUMERO DE CHEQUE") {
        axios
          .post(
            "api/FormBauchers/Crear",
            {
              idUsuario: me.$store.state.usuario.idUsuario,
              idbaseproveedorBaucher: me.idbaseproveedorBaucher,
              correlativo:
                me.año.toString() +
                "" +
                me.mes.toString() +
                "" +
                me.contadorID.toString(),
              fecha: me.fecha,
              numeroChequeTransferencia: "C-" + me.numeroChequeTransferencia,
              banco: me.banco,
              recibiDe: me.recibiDe,
              cantidadDe: me.cantidadDe,
              conceptoDe: me.conceptoDe,
              quienRecibi: me.quienRecibi,
              dui: me.dui,
              nit: me.nit,
              ncr: me.ncr,
              cuentaBanco: me.cuentaBanco,
              honorarios: honorarios,
              renta: renta,
              subTotal: subTotal,
              iva: me.iva,
              total: me.total,
            },
            configuracion
          )
          .then(function (response) {
            if (response.status == 200) {
              me.overlay = false;
            }
            me.contadorID = 0;
            me.limpiar();
            me.listar();
          })
          .catch(function (error) {
            console.log(error);
            me.snackError = true;
            me.overlay = false;
          });
      } else {
        axios
          .post(
            "api/FormBauchers/Crear",
            {
              idUsuario: me.$store.state.usuario.idUsuario,
              idbaseproveedorBaucher: me.idbaseproveedorBaucher,
              correlativo: me.correlativo,
              fecha: me.fecha,
              numeroChequeTransferencia: "T-" + me.numeroChequeTransferencia,
              banco: me.banco,
              recibiDe: me.recibiDe,
              cantidadDe: me.cantidadDe,
              conceptoDe: me.conceptoDe,
              quienRecibi: me.quienRecibi,
              dui: me.dui,
              nit: me.nit,
              ncr: me.ncr,
              cuentaBanco: me.cuentaBanco,
              honorarios: honorarios,
              renta: renta,
              subTotal: subTotal,
              iva: me.iva,
              total: me.total,
            },
            configuracion
          )
          .then(function (response) {
            if (response.status == 200) {
              me.overlay = false;
            }
            me.contadorID = 0;
            me.limpiar();
            me.listar();
          })
          .catch(function (error) {
            console.log(error);
            me.snackError = true;
            me.overlay = false;
          });
      }
    },
    actualizar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.overlay = true;
      var honorarios = parseFloat(me.honorarios);
      var renta = parseFloat(me.renta);
      var subTotal = parseFloat(me.subTotal);
      if (me.chequeTransferencia == "NUMERO DE CHEQUE") {
        axios
          .put(
            "api/FormBauchers/Actualizar",
            {
              idBaucher: me.idBaucher,
              idUsuario: me.$store.state.usuario.idUsuario,
              idbaseproveedorBaucher: me.idbaseproveedorBaucher,
              correlativo: me.correlativo,
              fecha: me.fecha,
              numeroChequeTransferencia: "C-" + me.numeroChequeTransferencia,
              banco: me.banco,
              recibiDe: me.recibiDe,
              cantidadDe: me.cantidadDe,
              conceptoDe: me.conceptoDe,
              quienRecibi: me.quienRecibi,
              dui: me.dui,
              nit: me.nit,
              ncr: me.ncr,
              cuentaBanco: me.cuentaBanco,
              honorarios: honorarios,
              renta: renta,
              subTotal: subTotal,
              iva: me.iva,
              total: me.total,
            },
            configuracion
          )
          .then(function (response) {
            if (response.status == 200) {
              me.overlay = false;
            }
            me.contadorID = 0;
            me.limpiar();
            me.listar();
          })
          .catch(function (error) {
            console.log(error);
            me.snackError = true;
            me.overlay = false;
          });
      } else {
        axios
          .put(
            "api/FormBauchers/Actualizar",
            {
              idBaucher: me.idBaucher,
              idUsuario: me.$store.state.usuario.idUsuario,
              idbaseproveedorBaucher: me.idbaseproveedorBaucher,
              correlativo: me.correlativo,
              fecha: me.fecha,
              numeroChequeTransferencia: "T-" + me.numeroChequeTransferencia,
              banco: me.banco,
              recibiDe: me.recibiDe,
              cantidadDe: me.cantidadDe,
              conceptoDe: me.conceptoDe,
              quienRecibi: me.quienRecibi,
              dui: me.dui,
              nit: me.nit,
              ncr: me.ncr,
              cuentaBanco: me.cuentaBanco,
              honorarios: honorarios,
              renta: renta,
              subTotal: subTotal,
              iva: me.iva,
              total: me.total,
            },
            configuracion
          )
          .then(function (response) {
            if (response.status == 200) {
              me.overlay = false;
            }
            me.contadorID = 0;
            me.limpiar();
            me.listar();
          })
          .catch(function (error) {
            console.log(error);
            me.snackError = true;
            me.overlay = false;
          });
      }
    },
    imprimir() {
      this.$refs.html2Pdf.generatePdf();
    },
    limpiar() {
      this.idBaucher = "";
      this.idUsuario = "";
      this.idbaseproveedorBaucher = "";
      this.correlativo = "";
      this.fecha = "";
      this.numeroChequeTransferencia = "";
      this.banco = "";
      this.recibiDe = "ASISTENCIA REGIONAL EL SALVADOR";
      this.cantidadDe = "";
      this.conceptoDe = "";
      this.quienRecibi = "";
      this.dui = "";
      this.nit = "";
      this.ncr = "";
      this.cuentaBanco = "";
      this.chequeTransferencia = "";
      this.verNuevo = 0;
      this.verBaucher = 0;
      this.fechaBD = "";
      this.honorarios = 0;
      this.renta = 0;
      this.subTotal = 0;
      this.iva = 0;
      this.total = 0;
      this.nombreProveedorItem = [];
    },
    calculoTotal() {
      var honorarios = Number(this.honorarios);
      var renta = Number(this.renta);
      var iva = Number(this.iva);

      this.subTotal = honorarios - renta;
      this.total = iva + this.subTotal;
      this.subTotal = this.subTotal.toFixed(2);
      this.total = this.total.toFixed(2);
    },
    descargarExcel() {
      let me = this;
      me.dataExcel = [];
      for (var i = 0; i < me.formularios.length; i++) {
        me.dataExcel.push({
          "RECIBO No": me.formularios[i].correlativo,
          "NUMERO DE CHEQUE": me.formularios[i].numeroChequeTransferencia,
          BANCO: me.formularios[i].banco,
          "RECIBI DE": me.formularios[i].recibiDe,
          "LA CANTIDAD DE": me.formularios[i].cantidadDe,
          "EN CONCEPTO DE": me.formularios[i].conceptoDe,
          "NOMBRE DE QUIEN RECIBE": me.formularios[i].quienRecibi,
          DUI: me.formularios[i].dui,
          NIT: me.formularios[i].nit,
          NCR: me.formularios[i].ncr,
          "CUENTA BANCO": me.formularios[i].cuentaBanco,
          HONORARIOS: me.formularios[i].honorarios,
          "RENTA (-)": me.formularios[i].renta,
          "SUB TOTAL": me.formularios[i].subTotal,
          IVA: me.formularios[i].iva,
          TOTAL: me.formularios[i].total,
        });
      }

      let data = XLSX.utils.json_to_sheet(me.dataExcel);
      const workbook = XLSX.utils.book_new();
      const filename = "Bauchers";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
  },
};
</script>

<style scoped>
.textStyle {
  padding-right: 0px;
  padding-left: 25px;
  padding-bottom: 20px;
  align-self: flex-end;
}
.textStyleHonorarios {
  padding-right: 40px;
  padding-left: 25px;
  padding-bottom: 20px;
  align-self: flex-end;
}
.textStyleRenta {
  padding-right: 30px;
  padding-left: 25px;
  padding-bottom: 20px;
  align-self: flex-end;
}
.textStyleSubTotal {
  padding-right: 17px;
  padding-left: 25px;
  padding-bottom: 20px;
  align-self: flex-end;
}
.textStyleIVA {
  padding-right: 75px;
  padding-left: 25px;
  padding-bottom: 20px;
  align-self: flex-end;
}
.textStyleTotal {
  padding-right: 50px;
  padding-left: 25px;
  padding-bottom: 20px;
  align-self: flex-end;
}
.styleLine {
  margin-top: 1px;
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 0px;
  padding-right: 3px;
}
.styleDolar {
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 10px;
}
.styleNumeros {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  margin-right: 0px;
  margin-top: 10px;
}
.styleFecha {
  padding-top: 0px;
  padding-right: 70px;
  justify-content: flex-end;
}
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap');
.styleText {
  font-family: "Open Sans", sans-serif;
}
</style>
